interface SectionWrapperProps {
  children: React.ReactNode;
  header: string;
}
const SectionWrapper = (props: SectionWrapperProps) => {
  const { header, children } = props;
  return (
    <section className="w-full h-fit my-3 flex flex-col items-center">
      <h2 className="border-b pb-4 pl-3 mb-3 font-semibold text-gray-600 w-full">
        {header}
      </h2>
      <div className="w-full flex flex-col">{children}</div>
    </section>
  );
};

export default SectionWrapper;
